import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '会展频道栏目改版';
const baseUrl = 'hzpd20221116';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: '开放高地',
      },
    },
    {
      path: 'hzjl',
      name: `${baseUrl}-hzjl`,
      component: () => import('./pages/Hzjl.vue'),
      meta: {
        title: '汇展经纶',
      },
    },
  ],
};

export default route;
